/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {upsertTask} from '../api'

export const useMutationUpsertTask = createReactQueryMutationHook('upsertTask', upsertTask)
